<template>
    <div :class="$style['select-user-fitter']">
        <div :class="$style['commonly-screen-user']" v-if="showBetchSelectUser">
        <wt-checkbox :checkList="checkList"  v-model="selectCheck"></wt-checkbox>
        <wt-radio :radios="radiosList" v-model="formValue.mallUserQuery" v-if="beatch"></wt-radio>
        </div>
        <div :class="$style['user-select-import']">
        <el-button type="primary" plain @click="selectShAarer" :disabled="isReward && importedCustomerTotal>0" :class="$style['click-select-user']" v-if="!showBetchSelectUser||showSelect">点击选择</el-button>
        <wt-upload-file-base :disabled="isReward && (selectUserList&&selectUserList.length > 0)" class="main-pictrue-upload" :action="uploadApi" @onError="onError"
            v-model="importRes" name="name" :multiple="false" listType="text" v-if="!showBetchSelectUser||showImport"
            >
                <el-button type="primary" :disabled="isReward && (selectUserList&&selectUserList.length > 0)">导入用户</el-button>
            </wt-upload-file-base>
            <!-- <wt-input v-model="selectUserList.length" style="display:none" data-vv-as="分享者" name="name"  v-validate="'required'"></wt-input> -->
        <span :class="$style['sharer-text']" v-if="isShowTxt">角色A：本活动中允许分享指定商品的用户</span>
        </div>
        <div :class="$style['select-user-name']" v-if="selectUserList&&selectUserList.length">
            <span>已选择 {{firstUserName}} {{selectUserList.length > 1 ? ('等'  +selectUserList.length +'位用户...') : ''}}</span>
            <el-button type="text" @click="viewUser">查看</el-button>
        </div>
         <div :class="$style['select-user-name']" v-if="importedCustomerTotal">
            <span>已导入 {{importedCustomerFirstName}} {{importedCustomerTotal> 1 ? ('等'  +importedCustomerTotal +'位用户...') : ''}}</span>
            <el-button type="text" @click="viewUserOfImport">查看</el-button>
        </div>
        <el-dialog :visible="is_dialog"  :title="dialog_title" @close="closeDialog"  :class="$style[(isSelectUser||(isViewUser&&!isImport))?'user-dialog':'default-dialog']">
            <select-view-user :fromPage="fromPage" v-if="isViewUser"  :pageSize="5" :userListId="userListId" :isImport="isImport" :userIds="formValue.ids" pageEdit @viewUserListDelete="viewUserListDelete"> </select-view-user>
            <select-for-user :paramsOfDefault="usersParams" :fromPage="fromPage" :selectedUser=" JSON.parse(JSON.stringify(selectUserList))" v-if="isSelectUser" :pageSize="5" @selectUsersSubmit="selectUsersSubmit" @close="closeDialog"></select-for-user>
            <import-not-system-customer v-if="isShowCustomerDialog" :customerOfinvalidTotal="customerOfinvalidTotal" :userListId="importRes.userListId" @cancel="cancel" @submit="submit"></import-not-system-customer>
        </el-dialog>
    </div>
</template>
<script>
import { screenUser, screenUserCheck } from 'json'
import selectViewUser from 'cps/customer-manage/select-view-user.vue'
import selectForUser from 'cps/customer-manage/select-for-user.vue'
import importNotSystemCustomer from './import-not-system-customer'
import formMixins from 'mixins/form'
export default {
  mixins: [formMixins],
  components: {
    selectViewUser,
    selectForUser,
    importNotSystemCustomer
  },
  props: {
    showBetchSelectUser: {
      type: Boolean,
      default: true
    },
    isShowTxt: {
      type: Boolean,
      default: true
    },
    label: {
      type: String,
      default: '分享者'
    },
    radios: {
      type: Array,
      default: function () {
        return screenUser
      }
    },
    fromPage: {
      type: String,
      default: null
    },
    selectedUserList: {
      type: Array,
      default: function () {
        return []
      }
    },
    selectedUserIdsList: {
      type: Array,
      default: function () {
        return []
      }
    },
    disableSelect: {
      type: Boolean,
      default: false
    },
    mallUserCriteria: {
      type: Object,
      default: function () {
        return {}
      }
    },
    isActive: {
      type: Boolean,
      default: false
    },
    usersParams: {
      type: Object
    },
    isReward: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    is_dialog: {
      get: function () {
        return this.isSelectUser || this.isViewUser || this.isShowCustomerDialog
      },
      set: function (val) {
        this.isSelectUser = val
        this.isViewUser = val
        this.isShowCustomerDialog = val
      }
    }
  },
  data () {
    return {
      formValue: {
        mallUserQuery: null,
        userListId: null
      },
      isViewUser: false,
      isSelectUser: false,
      dialog_title: '',
      uploadApi: this.$apiServer + '/mallsales/api/mall-user-import/import',
      uploadParamsData: {},
      importRes: {},
      isShowCustomerDialog: false,
      firstUserName: null,
      selectUserList: JSON.parse(JSON.stringify(this.selectedUserList)) || [],
      customerOfinvalidTotal: null,
      cunstomerOfValidTotal: null,
      selectUserListEdit: [],
      mallUser_query: null,
      radiosList: JSON.parse(JSON.stringify(this.radios)),
      showSelect: false,
      checkList: screenUserCheck,
      showImport: false,
      selectCheck: [],
      beatch: false,
      importedCustomerTotal: 0,
      importedCustomerFirstName: null,
      isImport: false,
      userListId: null,
      whiteListData: null
    }
  },
  watch: {
    mallUserCriteria: {
      handler: function (val) {
        if (val) {
          let userListId = null
          let mallUserQuery = null
          if (val.whiteList && val.whiteList.length) {
            val.whiteList.forEach(item => {
              if (item.userListId) {
                userListId = item.userListId
              }
              if (item.forAllUser) {
                mallUserQuery = 'ALL'
                this.whiteListData = 'forAllUser'
              } else if (item.gender) {
                mallUserQuery = mallUserQuery || item.gender
              } else if (item.role) {
                mallUserQuery = mallUserQuery || item.role
              } else {
                mallUserQuery = mallUserQuery || (item.bindCps ? 'bindCps' : (item.bindCps === false ? 'bindCpsFalse' : null))
              }
            })
          }
          if (val.blackList && val.blackList.length) {
            val.blackList.forEach(etem => {
              if (etem.enableSalesMan && this.whiteListData === 'forAllUser') {
                mallUserQuery = 'enableSalesMan'
              }
            })
          }
          if (userListId) {
            this.uploadParamsData.importMethod = 'NEW_AND_COPY'
            // this.isActive ? 'NEW_AND_COPY' : 'APPEND'
            this.uploadParamsData.userListId = userListId
            this.userListId = userListId
            this.formValue.userListId = userListId
            if (this.formValue.userListId) {
              this.selectCheck.push('import')
            }
            this.importedCustomer(userListId)
            this.uploadApi = this.$apiServer + '/mallsales/api/mall-user-import/import?importMethod=' + this.uploadParamsData.importMethod + '&userListId=' + userListId
          } else {
            this.uploadParamsData.importMethod = 'NEW'
            this.uploadApi = this.$apiServer + '/mallsales/api/mall-user-import/import?importMethod=' + this.uploadParamsData.importMethod
            if (this.isReward) {
              this.uploadApi = this.uploadApi + '&checkMoney=true'
            }
          }
          if (mallUserQuery) {
            this.formValue.mallUserQuery = mallUserQuery
            this.selectCheck.push('beatch')
          }
          this.selectUserList = val.whiteListSpecificUserIds
          if (this.selectUserList && this.selectUserList.length) {
            this.selectCheck.push('select')
          }
          if (val.whiteListSpecificUserIds) {
            this.$set(this.formValue, 'ids', val.whiteListSpecificUserIds)
          }
        }
      },
      immediate: true
    },
    selectedUserList: {
      handler: function (val) {
        this.userData(val)
      },
      deep: true,
      immediate: true
    },
    importRes (val) {
      if (val) {
        this.customerOfinvalidTotal = val.invalidTotal
        this.cunstomerOfValidTotal = val.validTotal
        if (val.checkSuccess) {
          this.$message.success('已有' + this.cunstomerOfValidTotal + '用户被导入')
          this.$set(this.formValue, 'userListId', val.userListId)
          this.$set(this, 'userListId', val.userListId)
          this.importedCustomer(val.userListId)
        } else {
          this.isShowCustomerDialog = true
          this.dialog_title = '不符合条件用户'
        }
      }
    },
    selectCheck: {
      handler: function (val) {
        if (val.indexOf('select') > -1) {
          this.showSelect = true
        } else {
          this.showSelect = false
          this.selectUserList = []
          this.formValue.ids = []
        }
        if (val.indexOf('beatch') > -1) {
          this.beatch = true
        } else {
          this.beatch = false
        }
        if (val.indexOf('import') > -1) {
          this.showImport = true
        } else {
          this.showImport = false
        }
        if (val.indexOf('beatch') < 0) {
          this.formValue.mallUserQuery = null
        }
        if (val.indexOf('select') < 0) {
          this.formValue.ids = []
        }
        if (val.indexOf('import') < 0) {
          this.importRes = null
          this.formValue.userListId = null
          this.userListId = null
          this.importedCustomerTotal = 0
        }
      },
      deep: true,
      immediate: true
    },
    formValue: {
      handler: function (val) {
        let data = {}
        if (this.showBetchSelectUser) {
          let mallUserCriteria = {
            whiteList: [
            ],
            blackList: []
          }
          /* whiteLis里面的多个对象的条件是并集，同一个对象里的数据是交集 */
          if (val.mallUserQuery) {
            switch (val.mallUserQuery) {
              case 'ALL':
                mallUserCriteria.whiteList.push({
                  forAllUser: val.mallUserQuery === 'ALL'
                })
                break
              case 'FEMALE':
                mallUserCriteria.whiteList.push({
                  gender: val.mallUserQuery
                })
                break
              case 'MALE':
                mallUserCriteria.whiteList.push({
                  gender: val.mallUserQuery
                })
                break
              case 'enableSalesMan':
                mallUserCriteria.blackList.push({
                  enableSalesMan: true
                })
                mallUserCriteria.whiteList.push({
                  forAllUser: true
                })
                break
              case 'DOCTOR_USER':
                mallUserCriteria.whiteList.push({
                  role: val.mallUserQuery
                })
                break
              case 'bindCps':
                mallUserCriteria.whiteList.push({
                  bindCps: true
                })
                break
              case 'bindCpsFalse':
                mallUserCriteria.whiteList.push({
                  bindCps: false
                })
            }
          }
          if (val.userListId) {
            mallUserCriteria.whiteList.push({
              userListId: val.userListId
            })
          }
          if (val.ids && val.ids.length) {
            mallUserCriteria.whiteList.push({
              ids: val.ids
            })
          } else {
            mallUserCriteria.whiteList.forEach((item, index) => {
              if (item.ids) {
                mallUserCriteria.whiteList.splice(index, 1)
              }
            })
          }
          // this.$delete(mallUserCriteria.whiteList[0], 'mallUserQuery')
          data.mallUserCriteria = mallUserCriteria
        } else {
          data = JSON.parse(JSON.stringify(val))
        }
        this.$emit('userSubmit', JSON.parse(JSON.stringify(data)))
      },
      deep: true
    }
  },
  methods: {
    onError (err) {
      this.$message.error(err && err.detail)
    },
    // 根据用户导入id，获取导入的用户列表
    importedCustomer (userListId) {
      let data = {
        pageable: {
          page: 0,
          size: 50
        },
        userListId: userListId
      }
      this.$emit('importLoading', true)
      this.$store.dispatch('importedCustomer', data).then(res => {
        this.importedCustomerTotal = res.totalNumber
        let data = res.data
        for (let i in data) {
          this.importedCustomerFirstName = data[i].name
          break
        }
        this.$emit('importLoading', false)
      }).catch(err => {
        this.$emit('importLoading', false)
        this.$message.error(err || '获取导入用户列表失败')
      })
    },
    submitData () {
      this.$set(this.formValue, 'userListId', this.importRes.userListId)
      let fromUser = JSON.stringify(this.formValue.ids.sort())
      let selectUser = JSON.stringify(this.selectedUserIdsList.sort())
      if (this.formValue.ids && fromUser !== selectUser) {
        this.$alert('手动筛选指定用户和批量导入指定用户只能选择一种方式', '导入提示', {
          confirmButtonText: '确定',
          type: 'warning'
        }).then(() => {
          if (this.selectedUserIdsList && this.selectedUserIdsList.length) {
            this.$set(this.formValue, 'ids', this.selectedUserIdsList)
          } else {
            this.$delete(this.formValue, 'ids')
          }
          this.selectUserList = JSON.parse(JSON.stringify(this.selectUserListEdit))
        })
      }
      if (this.formValue.mallUserQuery !== this.mallUser_query) {
        this.$alert('手动筛选指定用户和批量导入指定用户只能选择一种方式', '导入提示', {
          confirmButtonText: '确定',
          type: 'warning'
        }).then(() => {
          this.$set(this.formValue, 'mallUserQuery', this.mallUser_query)
        })
      }
    },
    submit () {
      this.isShowCustomerDialog = false
      this.$message.success('已有' + this.cunstomerOfValidTotal + '用户被导入')
      // let _this = this
      this.$set(this.formValue, 'userListId', this.importRes.userListId)
      this.$set(this, 'userListId', this.importRes.userListId)
      this.importedCustomer(this.importRes.userListId)
      setTimeout(function () {

        // _this.submitData()
        // if (this.cunstomerOfValidTotal > 0) {
        // }
      }, 300)
    },
    cancel () {
      this.deleteImportCustomer(this.importRes.userListId)
      this.isShowCustomerDialog = false
      // this.formValue.userListId = null
    },

    // 删除已导入的excel列表
    deleteImportCustomer (id) {
      this.$store.dispatch('deleteImportCustomer', id).then(res => {
        // this.$message.success('删除数据成功')
        console.log('删除数据成功')
      }).catch(err => {
        this.$message(err || '删除旧的导入数据失败')
      })
    },
    viewUserListDelete (val, rows) {
      this.userData(rows, val)
    },
    viewUser () {
      this.isImport = false
      this.isViewUser = true
      this.dialog_title = '查看用户'
    },
    // 用户数据处理
    userData (val, ids) {
      let firstUserName = ''
      this.$set(this.formValue, 'ids', [])
      // this.formValue.userIds = []
      if (ids) {
        for (let i in ids) {
          this.formValue.ids.push(ids[i])
        }
      } else {
        for (let i in val) {
          this.formValue.ids.push(val[i].id)
        }
      }
      for (let i in val) {
        if (val[i].fullName) {
          firstUserName = val[i].fullName
          break
        }
      }
      this.firstUserName = firstUserName
      this.selectUserList = ids || val
      this.firstUserName = firstUserName
    },
    selectUsersSubmit (val) {
      this.isSelectUser = false
      // this.formValue.userIds = this.formValue.userIds || []
      this.userData(val)
    },
    selectShAarer () {
      this.dialog_title = '选择用户'
      this.isSelectUser = true
    },

    closeDialog () {
      this.is_dialog = false
    },
    viewUserOfImport () {
      this.isImport = true
      this.isViewUser = true
      this.dialog_title = '查看用户'
    }
  },
  created () {
    this.selectUserListEdit = JSON.parse(JSON.stringify(this.selectedUserList))
  }
}
</script>
<style lang="less" module>

@import "~less/var.less";

.select-user-name{
    line-height: 40px;
    margin-top: 20px;
    :global
    .el-button--text{
        margin-left: 10px;
    }
}
.sharer-text{
    color: @tipTextColor;
    margin-left: 20px;
    font-size: 13px;
    line-height:40px
}
.select-user-fitter{
  :global
  .main-pictrue-upload{

  }

}
.commonly-screen-user{
  :global
  .el-checkbox-group{
    line-height: 40px;
    label{
      line-height: 40px
    }
  }
  :global
  .el-radio-group{
    line-height: 40px;
    label{
      line-height: 40px
    }
  }
}
.user-select-import{
  display:flex
}
.click-select-user{
  margin-right:15px;
  height: 40px;
}
.user-dialog{
  top: 10px;
    :global
    .el-dialog{
      top: 50px;
        width: 70%;
        min-width:1100PX;
        max-width:1500Px;
    }
}
.default-dialog{

  top: 10px;
    :global
    .el-dialog{
      top: 50px;
        width: 50%;
        min-width:600PX;
        max-width:800Px;
    }
}
</style>
